import React, { useEffect } from 'react'
import { useField } from 'formik'
import {
  InputFieldAcceptProps,
  InputFieldProps,
} from '@components/form/CheckboxField/interface'

const withCheckboxField = (Component: React.FC<InputFieldProps>) => {
  function Hoc(props: InputFieldAcceptProps) {
    const [field, meta, { setValue }] = useField(props)

    const newProps = {
      ...props,
      ...meta,
      ...field,
    }

    return <Component {...newProps} />
  }

  return Hoc
}

export { withCheckboxField }
